/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Checkbox } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setSelected } from '@/features/table/dealsTableSlice';
import { MAX_TABLE_SELECTION } from '@/components/table/data';

const PolicyRowCheckbox = ({ policy }) => {
	const dispatch = useDispatch();
	const { selected } = useSelector((state) => state.dealTable);

	const checkboxChecked = selected.some((s) => s?.Id == policy?.Id);

	const disabled =
		!policy?.ClientDocId ||
		(selected.length > 0 && selected.some((s) => s?.ClientId !== policy?.ClientId)) ||
		(!checkboxChecked && selected.length >= MAX_TABLE_SELECTION);

	return (
		<Checkbox
			disabled={disabled}
			checked={checkboxChecked}
			onClick={(e) => e.stopPropagation()}
			onChange={() => {
				if (checkboxChecked) {
					dispatch(setSelected(selected.filter((s) => s?.Id !== policy?.Id)));
				} else {
					dispatch(setSelected([...selected, policy]));
				}
			}}
			sx={{
				'&.Mui-disabled': {
					cursor: null,
				},
			}}
		/>
	);
};

export default PolicyRowCheckbox;
